<template>
  <div>
    <v-bottom-sheet max-width="620" v-model="rowDailog" persistent inset v-if="selectedRow">
      <v-card class="quick-report-sheet">
        <header class="quick-report-header">
          <div class="employee-summary">
            <span class="employee-initial">{{ selectedRow.name ? selectedRow.name.charAt(0).toUpperCase() : "E" }}</span>
            <div>
              <small>Employee quick view</small>
              <h2>{{ selectedRow.name }}</h2>
            </div>
          </div>
          <v-btn class="quick-report-close" icon @click.stop.prevent="close" aria-label="Close quick report">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </header>

        <div class="quick-report-controls">
          <div class="week-switcher" role="tablist" aria-label="Report week">
            <button v-for="(period, index) in list" :key="period.name" type="button"
              :class="{ active: selectedDate === index }" @click="selectedDate = index">
              {{ period.name }}
            </button>
          </div>
          <div class="date-range">
            <v-icon small>mdi-calendar-range</v-icon>
            {{ dateTime.start | moment("MMM D") }} – {{ dateTime.end | moment("MMM D, YYYY") }}
          </div>
        </div>

        <div v-if="loading" class="quick-report-loading">
          <v-progress-circular :width="3" color="primary" indeterminate></v-progress-circular>
          <span>Loading attendance…</span>
        </div>

        <div v-else class="quick-report-days">
          <button v-for="([date, day]) in dayEntries" :key="date" type="button" class="quick-day-card"
            @click.stop.prevent="openDetail(day)">
            <div class="quick-day-heading">
              <div>
                <strong>{{ day.row[0].clockInTime | moment("dddd") }}</strong>
                <span>{{ date }}</span>
              </div>
              <span class="quick-entry-count">{{ day.row.length }} {{ day.row.length === 1 ? "entry" : "entries" }}</span>
            </div>

            <v-progress-linear :color="barColor(day)" height="7" rounded background-opacity="0.15"
              :value="duration(day.totalInSeconds)"></v-progress-linear>

            <div class="quick-day-footer">
              <span v-if="employeeAccess.report && employeeAccess.report.showHours" class="quick-worked">
                <v-icon small>mdi-clock-outline</v-icon>{{ secondsToHms(day.totalInSeconds) }}
              </span>
              <span v-if="day.row[0].TimeClockPayId" class="quick-paid">
                <v-icon small>mdi-check</v-icon>Paid
              </span>
              <span v-if="day.astrid" class="quick-open">Open shift</span>
              <span v-else-if="day.early && employeeAccess.report && employeeAccess.report.showHours"
                class="quick-short">{{ secondsToHms(day.early) }} short</span>
              <v-icon class="quick-chevron">mdi-chevron-right</v-icon>
            </div>
          </button>

          <div v-if="dayEntries.length === 0" class="quick-report-empty">
            <v-icon>mdi-calendar-blank-outline</v-icon>
            <strong>No shifts this week</strong>
            <span>There are no recorded time entries for this period.</span>
          </div>
        </div>

        <DayDetail @submit="dataSave" @close="dayDetailDialog = false" :dialog="dayDetailDialog"
          :selectedRow="daySelected" />
      </v-card>
    </v-bottom-sheet>
  </div>
</template>

<script>
// import EmployeeReport from "@/modules/Reports/components/DetailReports.vue";
import _ from "lodash";
import timeClockService from "@/modules/TimeClock/service";
import { mapGetters } from "vuex";
import DayDetail from "@/modules/Reports/components/DayDetail.vue";

export default {
  name: "quick-repot",
  props: ["dialog", "selectedRow"],
  data() {
    return {
      daySelected: null,
      dayDetailDialog: false,
      reload: false,
      totalSeconds: 0,
      unGroupList: [],
      workingHours: 12,
      selectedDate: 1,
      loading: false,
      list: [
        {
          name: "Last Week",
          start: this.$moment()
            .subtract(1, "week")
            .startOf("week")
            .toISOString(),
          end: this.$moment().subtract(1, "week").endOf("week").toISOString(),
        },
        {
          name: "This Week",
          start: this.$moment().startOf("week").toISOString(),
          end: this.$moment().endOf("week").toISOString(),
        },
      ],
      rowDailog: false,
      dateTime: {
        start: this.$moment().startOf("week").toISOString(),
        end: this.$moment().endOf("week").toISOString(),
      },
    };
  },
  watch: {
    selectedDate(i) {
      this.dateTime.start = this.list[i].start;
      this.dateTime.end = this.list[i].end;
      this.loadTimeClock();
    },
    dialog(val) {
      this.rowDailog = val;
      if (val) {
        this.loadTimeClock();
      }
      // console.log("selectedRow", this.selectedRow);
    },
  },
  computed: {
    ...mapGetters("employee", ["employeeAccess"]),
    dayEntries() {
      return Object.entries(this.unGroupList);
    },
  },
  components: {
    DayDetail,
  },
  methods: {
    close() {
      this.selectedDate = 1

      this.$emit("close");
    },
    openDetail(row) {
      this.daySelected = row;
      this.reload = true;
      this.dayDetailDialog = !this.dayDetailDialog;
    },
    duration(seconds) {
      let value = 10;

      const totalTime = this.workingHours * 60 * 60;
      // console.log('row', row, totalTime)
      value = (seconds / totalTime) * 100;
      return value;
    },
    barColor(obj) {
      const totalSeconds = Number(this.workingHours) * 60 * 60;
      if (obj.astrid) {
        return "#4f9cf9";
      }
      const isShort = Number(obj.totalInSeconds) < totalSeconds;
      this.$set(obj, "early", isShort ? totalSeconds - Number(obj.totalInSeconds) : 0);
      return isShort ? "#ef4d5a" : "#35b978";
    },
    secondsToHms(d) {
      d = Number(d);
      var h = Math.floor(d / 3600);
      var m = Math.floor((d % 3600) / 60);
      var s = Math.floor((d % 3600) % 60);

      // console.log('AndDown', this.$vuetify.breakpoint.xsOnly)

      var hDisplay = h > 0 ? h + (h == 1 ? " hour, " : " hours, ") : "";
      var mDisplay = m > 0 ? m + (m == 1 ? " minute, " : " minutes, ") : "";
      var sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";

      if (this.$vuetify.breakpoint.xsOnly) {
        hDisplay = h > 0 ? h + " h, " : "";
        mDisplay = m > 0 ? m + " m, " : "";
        sDisplay = s > 0 ? s + " s " : "";
      }

      return hDisplay + mDisplay + sDisplay;
    },
    dataSave() {
      this.reload = true;
      this.loadTimeClock();
       this.dayDetailDialog = false
      this.dialog = false;
    },
    loadTimeClock() {
      console.log("loading data");
      this.loading = true;
      this.unGroupList = [];
      const dataObj = {
        start: this.dateTime.start,
        end: this.dateTime.end,
        EmployeeId: this.selectedRow.id,
      };
      // console.log("dataObj", dataObj);
      return timeClockService
        .getEmployeeTimeClockReport(dataObj)
        .then((response) => {
          // console.log("loadTimeClock", response);
          this.totalSeconds = 0;
          this.unGroupList = _.mapValues(
            _.groupBy(response.data.timeClockList, (row) => {
              if (row.TimeClockPayId) this.showPayBtn = false;
              return this.$moment(row.clockInTime).format("MM/DD/YYYY");
            }),
            (list) => {
              // console.log('printing list', list)
              // let newlist = []
              if (list.length > 1) {
                let seconds = 0;
                let astrid = false;
                list.map((row) => {
                  if (row.clockOutTime) {
                    seconds += row.shiftDuration.totalInSeconds;
                    this.totalSeconds += row.shiftDuration.totalInSeconds;
                  } else {
                    astrid = true;
                  }
                });
                // newlist.push({
                //     createdAt: list[0].createdAt,
                //     totalInSeconds: seconds
                // })
                return {
                  clockInTime: list[0].clockInTime,
                  astrid,
                  totalInSeconds: seconds,
                  metadata: list[0].Employee.metadata,
                  row: list,
                };
              } else {
                this.totalSeconds += list[0].shiftDuration.totalInSeconds;
                return {
                  id: list[0].id,
                  clockInTime: list[0].clockInTime,
                  astrid: list[0].clockOutTime ? false : true,
                  totalInSeconds: list[0].shiftDuration.totalInSeconds,
                  metadata: list[0].Employee.metadata,
                  row: list,
                };
              }
            }
          );

          this.timeClockList = response.data.timeClockList;
          this.totalTime = response.data.totalTime;
          this.count = this.timeClockList.length;
          if (!this.empData) {
            if (this.timeClockList.length > 1) {
              this.empData = this.timeClockList[0].Employee;
            }
          }
          // console.log("this.unGroupList", this.unGroupList);
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          console.log("error is :", error);
        });
    },
  },
};
</script>

<style scoped>
.quick-report-sheet {
  background: var(--v-surface-base) !important;
  border: 1px solid var(--v-border-base);
  border-radius: 22px 22px 0 0 !important;
  color: var(--v-textPrimary-base);
  max-height: min(86vh, 800px);
  overflow: hidden;
}

.quick-report-header,
.employee-summary,
.quick-day-heading,
.quick-day-footer {
  align-items: center;
  display: flex;
}

.quick-report-header {
  border-bottom: 1px solid var(--v-border-base);
  justify-content: space-between;
  padding: 18px 20px;
}

.employee-summary {
  gap: 11px;
  min-width: 0;
}

.employee-initial {
  align-items: center;
  background: rgba(96, 165, 250, 0.13);
  border: 1px solid rgba(96, 165, 250, 0.24);
  border-radius: 13px;
  color: var(--v-primary-base);
  display: flex;
  flex: 0 0 44px;
  font-size: 1.05rem;
  font-weight: 800;
  height: 44px;
  justify-content: center;
}

.employee-summary small {
  color: var(--v-textSecondary-base);
  display: block;
  font-size: 0.62rem;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.employee-summary h2 {
  color: var(--v-textPrimary-base);
  font-size: 1.15rem;
  margin: 2px 0 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.quick-report-close {
  background: var(--v-surfaceMuted-base);
  color: var(--v-textPrimary-base);
}

.quick-report-controls {
  background: var(--v-surfaceMuted-base);
  border-bottom: 1px solid var(--v-border-base);
  padding: 14px 18px 12px;
}

.week-switcher {
  background: var(--v-surface-base);
  border: 1px solid var(--v-border-base);
  border-radius: 12px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding: 4px;
}

.week-switcher button {
  border: 0;
  border-radius: 9px;
  color: var(--v-textSecondary-base);
  cursor: pointer;
  font: inherit;
  font-size: 0.8rem;
  font-weight: 750;
  padding: 9px;
}

.week-switcher button.active {
  background: var(--v-primary-base);
  color: white;
  box-shadow: 0 5px 14px rgba(37, 99, 235, 0.22);
}

.date-range {
  align-items: center;
  color: var(--v-textSecondary-base);
  display: flex;
  font-size: 0.7rem;
  gap: 5px;
  justify-content: center;
  margin-top: 9px;
}

.date-range .v-icon {
  color: var(--v-textSecondary-base);
}

.quick-report-days {
  max-height: calc(min(86vh, 800px) - 190px);
  overflow-y: auto;
  padding: 14px;
}

.quick-day-card {
  appearance: none;
  background: var(--v-surfaceMuted-base);
  border: 1px solid var(--v-border-base);
  border-radius: 14px;
  color: var(--v-textPrimary-base);
  cursor: pointer;
  display: block;
  font: inherit;
  margin-bottom: 10px;
  padding: 13px;
  text-align: left;
  width: 100%;
}

.quick-day-card:hover {
  border-color: rgba(96, 165, 250, 0.45);
  transform: translateY(-1px);
}

.quick-day-heading {
  justify-content: space-between;
  margin-bottom: 11px;
}

.quick-day-heading strong,
.quick-day-heading span {
  display: block;
}

.quick-day-heading strong {
  font-size: 0.88rem;
}

.quick-day-heading div > span,
.quick-entry-count {
  color: var(--v-textSecondary-base);
  font-size: 0.68rem;
}

.quick-entry-count {
  background: var(--v-surface-base);
  border: 1px solid var(--v-border-base);
  border-radius: 999px;
  padding: 4px 9px;
}

.quick-day-footer {
  gap: 7px;
  margin-top: 10px;
  min-width: 0;
}

.quick-worked {
  align-items: center;
  display: flex;
  font-size: 0.72rem;
  font-weight: 700;
  gap: 4px;
}

.quick-worked .v-icon {
  color: var(--v-textSecondary-base);
}

.quick-paid,
.quick-open {
  border-radius: 999px;
  font-size: 0.62rem;
  font-weight: 800;
  padding: 3px 7px;
}

.quick-paid {
  background: rgba(45, 190, 126, 0.12);
  color: #31c989;
}

.quick-open {
  background: rgba(79, 156, 249, 0.12);
  color: #4f9cf9;
  margin-left: auto;
}

.quick-short {
  color: #f36b75;
  font-size: 0.7rem;
  font-weight: 750;
  margin-left: auto;
  white-space: nowrap;
}

.quick-chevron {
  color: var(--v-textSecondary-base);
  margin-left: 2px;
}

.quick-report-loading,
.quick-report-empty {
  align-items: center;
  color: var(--v-textSecondary-base);
  display: flex;
  flex-direction: column;
  gap: 7px;
  justify-content: center;
  min-height: 180px;
  padding: 24px;
  text-align: center;
}

.quick-report-loading {
  flex-direction: row;
}

.quick-report-empty .v-icon {
  color: var(--v-textSecondary-base);
  font-size: 36px;
}

.quick-report-empty strong {
  color: var(--v-textPrimary-base);
}

.quick-report-empty span {
  font-size: 0.75rem;
}

@media (max-width: 600px) {
  .quick-report-sheet {
    max-height: 90vh;
  }

  .quick-report-header {
    padding: 15px 16px;
  }

  .quick-report-controls {
    padding: 12px 14px 10px;
  }

  .quick-report-days {
    max-height: calc(90vh - 178px);
    padding: 12px;
  }

  .quick-day-footer {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto auto;
  }

  .quick-short,
  .quick-open {
    grid-column: 2;
  }

  .quick-chevron {
    grid-column: 3;
  }
}
</style>
